import { BaseEntity } from "./../baseEntity";
export class UserRequest extends BaseEntity {
}
export class UserResponse extends BaseEntity {
}
export class UserRoleRequest {
}
export class UserRoleResponse extends BaseEntity {
}
